import CollapseMobileMenuItem from './Component';

export default CollapseMobileMenuItem;